import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import { BaseComponent } from 'src/app/base/base.component';
import { AlertController, LoadingController, MenuController } from '@ionic/angular';
import { AuthService } from 'src/app/guards/auth.service';
import { PagesToNavigateService } from 'src/app/base/pages.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage extends BaseComponent implements OnInit {

  constructor(
    protected router: Router,
    protected storageService: StorageService,
    protected loadingCtrl: LoadingController,
    protected alertController: AlertController,
    protected authService: AuthService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    super(loadingCtrl, router, storageService, alertController, authService, pagesToNavigateService);
  } 

async  ngOnInit() {
    let bearerToken = await this.storageService.getStorageSync('TOKENJAVA');
    console.log("bearerToken", bearerToken);
  }

  enroll(): void {

    this.storageService.getStorage('TOKEN').then(token => {
      this.storageService.getStorage('userId').then(userId => {
        this.storageService.getStorage('speakerUser').then(speaker => {
          this.storageService.getStorage('TOKENJAVA').then((tokeJava)=>{

            if (speaker.value === null) {
              this.storageService.getStorage('speaker').then(speakers => {
                this.storageService.emptyStorage().then();
                this.storageService.saveToStorage('speakerUser', speakers.value);
                this.storageService.saveToStorage('TOKEN', token.value);
                this.storageService.saveToStorage('userId', userId.value);
                this.storageService.saveToStorage('TOKENJAVA', tokeJava.value);
              });
            }else{
              this.storageService.emptyStorage().then();
              this.storageService.saveToStorage('speakerUser', speaker.value);
              this.storageService.saveToStorage('TOKEN', token.value);
              this.storageService.saveToStorage('userId', userId.value);
              this.storageService.saveToStorage('TOKENJAVA', tokeJava.value);
            }
  
            this.router.navigate(['aviso-privacidad']);

          });
        });
      });
    });

  }
  v(){
    this.router.navigate(['/verificar-cliente']);
  }

  firmaContrato(): void {
    this.router.navigate(['bandeja-contratos']);

  }

}
